export const filterInitialState = {
  accounts: [],
};
